export const filterInitialState = {
  accounts: [],
};
